import { toJS } from "mobx";
import { ZClassUnsafe } from "src/business/classes";
import { getParentClassId } from "src/business/classes/getParentClassId";
import { makeClassInternalData } from "src/business/classes/makeClassInternalData";
import { ZSpecCommon } from "src/business/specification";
import { ZSecSpecRow } from "src/business/specification/ZSecSpecRow";
import { delay } from "src/common/delay";
import { MFormStore } from "src/components/MForm/MFormStore";

/**
 * В результате изменения списка вторичных спецификаций на форме происходит изменение метаданных.
 * Должны исчезнуть или появиться новые разделы
 */
export const updateSecondarySpecs = async (
  classData: ZClassUnsafe,
  form: MFormStore,
  newList: ZSecSpecRow[],
) => {
  // Здесь выбран более простой и надёжный вариант изменения метаданных путём полной замены.
  // Т.е. единственное место, где формируется структура узлов - это makeClassInternalData.

  // Но возможен и альтернативный вариант, где удаление/добавление разделов вторичных спек можно было бы выполнять
  // прямо над существующей структурой узлов.
  // Минусы: нарушение инкапсуляции и потребовалось бы усложнение кода.
  // Плюс в том, что в узлах сохранилось бы состояние
  const oldValue = toJS(form.root.value);
  const specs: ZSpecCommon[] = [...newList];
  if (classData.primarySchema) {
    specs.unshift(classData.primarySchema);
  }
  const { meta } = makeClassInternalData(
    classData,
    specs,
    getParentClassId(classData),
    "specs",
  );
  form.setMeta(meta, "NoInit");
  await delay(1);
  form.setFieldsValue(oldValue);
};
